import React, { useContext, useEffect, useState } from "react";
import PropTypes from 'prop-types'
import BasicSelector from "../Basic/BasicSelector";
import { VesselDwtTypesContext } from "../TcIndexPage";

function DwtGroup({ 
    vesselType, 
    changeFieldsMultiple, 
    countIndex, 
    required = false, 
    setHasErrors, 
    disabled = false,
    currentTypeGeneral,
}) {
    const vesselDwtTypes = useContext(VesselDwtTypesContext);
    const [dataList, setDataList] = useState(vesselDwtTypes);

    const selectVesselType = (_id) => {
        const toChange = [
            {
                index: countIndex,
                field: 'vesselDwtGroup',
                value: vesselDwtTypes.find(t => t._id === _id),
            }
        ];

        toChange.push(
            {
                index: countIndex,
                field: 'vesselId',
                value: '',
            },
            {
                index: countIndex,
                field: 'vessel.imoNumber',
                value: '',
            },
        );
        
        changeFieldsMultiple(toChange);
    }

    useEffect(() => {
        if (required) {
            if (!vesselType || !vesselType._id) {
                setHasErrors('vesselDwtGroup', true)
            } else {
                setHasErrors('vesselDwtGroup', false)
            };
        }
    }, [vesselType]);

    useEffect(() => {
        if (currentTypeGeneral) {
            setDataList(vesselDwtTypes.filter(d => {
                return d.typeByPurpose.includes(currentTypeGeneral);
            }));
        }
    }, [currentTypeGeneral]);
    return (
        <BasicSelector 
            value={vesselType && vesselType._id}
            dataList={dataList}
            onChange={(e, _i, value) => selectVesselType(value)}
            iconStyle={{ display: 'none' }}
            underlineStyle={{ display: 'none' }}
            style={{ fontSize: '9px' }}
            labelStyle={{ padding: 0, top: 'unset' }}
            fields={['min', 'max']}
            disabled={disabled}
        />
    );
}

DwtGroup.protoTypes = {
    vesselType: PropTypes.shape({
        _id: PropTypes.string,
        max: PropTypes.number,
        min: PropTypes.number,
        name: PropTypes.string,
    }),
    changeFieldsMultiple: PropTypes.func,
    countIndex: PropTypes.number
};


export default React.memo(DwtGroup);


// WEBPACK FOOTER //
// ./app/components/TcIndex/RowData/DwtGroup.jsx